import { RouteName } from "constant/routeNames";
import { Link } from "react-router-dom";
import LazyLoadImg from "components/LazyLoadImg";
import { Tooltip as ReactTooltip } from "react-tooltip";

const ArtistCard = ({ artist, isLoading }: any) => {
  return (
    <>
      {!isLoading && (
        <div>
          {artist && (
            <Link
              to={RouteName.VideoCreatorHomeRoute.replace(
                ":slug",
                `@${artist?.slug}`
              )}
            >
              <div className="group mx-auto flex w-full flex-col items-center px-2 py-2 text-center">
                {/* image */}
                <div className="relative mx-auto aspect-square w-full max-w-[116px] overflow-hidden rounded-full ring-1 ring-white/10 transition-all duration-300 group-hover:ring-2 group-hover:ring-[var(--red)]/50">
                  <LazyLoadImg
                    imgSrc={
                      artist?.profile_image ||
                      artist?.artwork_url ||
                      artist?.thumbnail_url
                    }
                    imgAlt={"Artist"}
                    imgHeight={"100%"}
                    imgWidth={"100%"}
                    wrapperProps={{
                      style: {
                        position: "absolute",
                        inset: 0,
                        width: "100%",
                        height: "100%",
                        display: "block",
                      },
                    }}
                    className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-110"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      objectPosition: "center",
                    }}
                  />
                </div>

                <p
                  className="mt-3 max-w-[126px] text-[14px] font-[600] text-white transition-colors group-hover:text-white"
                  dangerouslySetInnerHTML={{ __html: artist?.name }}
                  data-tooltip-id={`music-artist-title-${artist?.name}`}
                ></p>
                {artist?.name.length > 28 && (
                  <div className="z-50 text-sm">
                    <ReactTooltip
                      id={`music-artist-title-${artist?.name}`}
                      place="bottom"
                      content={artist?.name}
                      style={{ width: "180px" }}
                    />
                  </div>
                )}
              </div>
            </Link>
          )}
        </div>
      )}
    </>
  );
};

export default ArtistCard;